import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import PricesLevels from "./PricesLevels";
const defaultAutos = {
    Branches: [],
};

export default function PricesLevelsCon() {

  const tb = {
    wait: true,
    other: true,
    SafesInv: true,
    UsersA: true,
    InvItems:true,
    Branch: true,
    Levels:true,
    Units: true,
    stor: { ...sto, branchi: sto.branchi },
    parms:{
      iempid: sto.empi,
      tname: "pricelevel",
      branch:  sto.branchi,
      db_name:sto?.db_name,
    }
};

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches 
  )
    return <LoadingPage />;

  return (
    <PricesLevels
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
      }}
    />
  );
}
